import { render, staticRenderFns } from "./copyLinkDialog.vue?vue&type=template&id=79e07c10&scoped=true&"
import script from "./copyLinkDialog.vue?vue&type=script&lang=js&"
export * from "./copyLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./copyLinkDialog.vue?vue&type=style&index=0&id=79e07c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e07c10",
  null
  
)

export default component.exports